export default [
  {
    text: 'Профессии',
    to: { name: 'professions', query: { sort: 'events_count' } },
    ico: 'professions',
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.professions.js